import {
  styled,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
} from "@mui/material";

const StyledTextField = styled(MuiTextField)(({ theme }) => {
  return {
    "& .MuiInputBase-root.Mui-disabled": {
      backgroundColor: theme.palette.textFieldDisabled?.background,
    },
    "& .MuiInputBase-input.Mui-disabled": {
      WebkitTextFillColor: theme.palette.textFieldDisabled?.textColor,
    },
  };
});

type TextFieldProps = MuiTextFieldProps & {
  id?: string;
};

export const TextField: React.FC<TextFieldProps> = ({ children, ...props }) => {
  return <StyledTextField {...props}>{children}</StyledTextField>;
};

export default TextField;
